import { DeliveryProvider, OFFER_KIND, PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  customer_info: {
    dummy_order: 'Commande test',
    ordered_at: 'Commandé à :',
  },
  delivery_info: {
    info: 'Infos de livraison :',
  },
  order_note: {
    label: 'Note de commande :',
  },
  schedule_info: {
    pickup: 'Retrait',
    delivery: 'Livraison',
    on_site: 'Commande à table',
    wish_time: 'Heure souhaitée :',
    confirmed_time: 'Heure confirmée :',
    driver_arrival_time: 'Heure de passage du livreur :',
    external_delivery: 'La commande est livrée par un livreur externe de {{carrier}}',
  },
  products: {
    item: 'Article :',
  },
  discount_breakdown: {
    label: 'Réduction',
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Remise en % sur le total appliquée',
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Remise en % sur les produits appliquée',
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Remise en montant sur les produits appliquée',
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Remise en montant sur le total appliquée',
    [OFFER_KIND.BOGO]: 'Bogo appliqué',
    [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo demi-tarif appliqué',
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Article gratuit sur produits appliqué',
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Article gratuit sur total appliqué',
    GiftCard: 'Carte cadeau appliquée',
    Reward: 'Points de fidélité appliqués',
    CashbackAccount: 'Points de fidélité appliqués',
    PromoCodeComponent: 'Promo appliquée',
    Offer: 'Offre appliquée',
  },
  payment_breakdown: {
    price: 'Prix :',
    subtotal: 'Sous-total',
    delivery_fee: 'Frais de livraison',
    tips: 'Pourboire',
    processing_fee: 'Frais de service en ligne',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Frais PayPal',
    },
    tax: 'Taxes',
    total: 'Total',
    paid_amount: 'Montant payé',
    order_not_paid: "La commande n'a pas encore été payée",
    order_paid_online: 'Déjà payé en ligne',
    cash: 'Paiement sur place',
    this_is_not_an_invoice: "Ceci n'est pas une facture",
  },
  delivery_qr_code: {
    scan: 'Scanner & livrer avec Google Maps',
  },
  delivery_providers: {
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
};
